<div class="common-modal">
    <div class="modal-body full-width">
        <p class="progress-heading">Processing… <span>{{processedCount}} / {{requestData.length}}</span></p>
        <div class="progress">
            <div class="progress-bar" [style.width.%]="processedCount/requestData.length*100" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
  </div>
